import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ManagersBusinessSectionsIndexType } from "~/domains";

type ParamsType = {
  keyword?: string;
};

type RequestDataType = {
  params?: {
    keyword?: string;
    businessDivisionIds?: string[];
    businessSectionIds?: string[];
  };
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ManagersBusinessSectionsIndexType> => {
  const response = await new ApiClient().get<ManagersBusinessSectionsIndexType>(
    "/api/managers/business_sections",
    { page, ...params },
  );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ParamsType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersBusinessSectionsIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ManagersBusinessSectionsIndexType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagersBusinessSectionsIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
